:host {
  width: 100%;
  position: absolute;
  color: #4a4a4a;
  background-color: #fff;
  padding: 16px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
  top: calc(100% + 5px);
  left: 0;
}
@media screen and (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait), screen and (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape), screen and (min-width: 840px) and (orientation: portrait), screen and (min-width: 1280px) and (orientation: landscape) {
  :host {
    width: 340px;
  }
}